import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';
import {useSelector} from 'react-redux';

import './index.scss';

import * as Routes from '../../../constants/routes';

//components
import Spinner from '../../../components/forms/spinner/spinner';
import Select from '../../../components/forms/select';

//assets
import arrow from 'assets/icons/slider-arrow-blue.svg';
import AutoComplete from "../../../components/forms/autocomplete";
import {getMediaPath, urlEncodeString} from "../../../app/functions";


const OrderDetails = (props) =>{

    const [query, setQuery] = useState('');

    const deliveryOptions = useSelector(store => store.config.Cart.deliveryOptions);

    const text = useSelector(store => store.config.Translations);

    const order = props.data;

    const spinners = props.spinnersData;


    const onSpinnerChange = (action,val, field, maxValue) =>{
        if (action === 'plus') {
            val++;
        } else {
            val--;
        }
        if (val <= maxValue && val > 0) {
            props.dataOnChange(props.id, field, val);
        }
    };

    const handleAutoCompleteOnSelect = (id, text) =>{
        setQuery(text);
        props.dataOnChange(props.id, 'branch_id', id);
    };

    const showBranches = parseInt(deliveryOptions[order.delivery_method_id]?.id) === 14;
    const showMassage = parseInt(deliveryOptions[order.delivery_method_id]?.id) === 16;

    const branchErrClass = parseInt(order.branch_id) === -1 && !props.firstTry;
    const deliveryErrClass = order.delivery_method_id === '' && !props.firstTry;


    const isMaxAmount = spinners.quantity >= order.max_amount ? ' plus-disabled' : '';
    const isMinAmount = spinners.quantity === 1 ? ' minus-disabled' : '';
    const isMaxPayments = spinners.payments >= order.max_payments ? ' plus-disabled' : '';
    const isMinPayments = spinners.payments === 1 ? ' minus-disabled' : '';
    return(
        <section className={'order-details ' + props.className}>
            <div className='product-details'>
                <NavLink to={Routes.commerce + '/' + order.item_id + '/' + urlEncodeString(order.title)}><img src={getMediaPath(order.image)} alt=''/></NavLink>
                <div className='details-wrapper'>
                    <NavLink to={Routes.commerce + '/' + order.item_id + '/' +order.cda +"/"+ urlEncodeString(order.title)}><h3 className='name'>{order.title}</h3></NavLink>
                    <span>{text['payment_tools'] + ' ' + order.sub_title}</span>
                    <span className='label'>{text['payment_supplier']}</span>
                    <span>{order.supplier.title}</span>
                </div>
            </div>

            <div className='configuration-container'>
                <Spinner className={'counter' + isMaxAmount + isMinAmount}
                         label={text['payments_quantity']}
                         amount={spinners.quantity}
                         onClick={(action)=> onSpinnerChange(action,spinners.quantity,'quantity', parseInt(order.max_amount))}
                />
                <Spinner className={'counter' + isMaxPayments + isMinPayments}
                         label={text['payment_num_of_payments']}
                         amount={spinners.payments}
                         onClick={(action)=> onSpinnerChange(action,spinners.payments,'payments', parseInt(order.max_payments))}
                />

                <div className={'delivery-wrapper ' + (deliveryErrClass ? 'err' : '')}>
                    <span>{text['payment_delivery_method']}</span>
                    <Select className="delivery-select"
                            deviceState={"desktop"}
                            options={order.deliveryMethods}
                            onChange={(val) => props.dataOnChange(props.id, 'delivery_method_id', val)}
                            arrow={getMediaPath(arrow)}
                            placeholder={text['payment_delivery_placeholder']}
                    />
                    {deliveryErrClass && <span className='err-msg'>שדה חובה</span>}
                </div>

                {showBranches &&
                <div className='branches-wrapper'>
                    <span>{text['payment_branches']}</span>

                    <AutoComplete className={"filter-autocomplete " + (branchErrClass ? 'err' : '')}
                                  placeholder={text['payment_branches_placeholder']}
                                  options={order.branches}
                                  onSelect={handleAutoCompleteOnSelect}
                                  query={query}
                                  onChange={(e) => setQuery(e.target.value)}
                                  onClear={() => {
                                      setQuery('')
                                  }}
                    />
                    {branchErrClass && <span className='err-msg'>שדה חובה</span>}
                </div>
                }
                {showMassage &&
                    <span className='delivery-desc'>{text['order_details_delivery_desc']}</span>
                }
            </div>
        </section>
    )
};

export default OrderDetails;